var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0457 2.90942C11.7322 2.3492 12.7455 2.38854 13.3855 3.02856L13.5046 3.16138C14.0277 3.80225 14.0276 4.72752 13.5046 5.36841L13.3855 5.50122L6.61987 12.2659C6.55597 12.3296 6.47599 12.3747 6.38843 12.3967L4.03491 12.9856C3.86459 13.0281 3.68444 12.9779 3.5603 12.8538C3.43617 12.7296 3.38597 12.5495 3.42847 12.3792L4.01733 10.0256L4.03784 9.96118C4.06284 9.89884 4.10042 9.84206 4.14819 9.79419L10.9128 3.02856L11.0457 2.90942Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91382 4.50024L11.9138 6.50024",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditColor);
export default __webpack_public_path__ + "static/media/edit-color.70c3226f1f258a82cd9c928d99dc8cb9.svg";
export { ForwardRef as ReactComponent };